import { createStyles, makeStyles } from '@material-ui/core';

interface StyleProps {
  isMobile: boolean;
}

export const useStyles = makeStyles(() =>
  createStyles({
    logo: {
      maxWidth: (props: StyleProps) => (props.isMobile ? '250px' : '350px'),
      maxHeight: (props: StyleProps) => (props.isMobile ? '50px' : '100px')
    }
  })
);
